import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IPostEnrollMerchantBankBody {
  bankCode: string;
  terminalId: string;
  merchantId: string;
}

export interface IPostEnrollMerchantBank {
  merchantId: number;
  body: IPostEnrollMerchantBankBody
}

export async function postEnrollMerchantBank(data: IPostEnrollMerchantBank): Promise<any> {
  try {
    return (await axiosInstance.post("/MerchantSoftPOSEnrollment/EnrollMerchantBank?merchantId=" + data.merchantId, data.body)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}